import {
  BabySection,
  IdealBabySection,
  IdealMeasurmentHeight,
  IdealMeasurmentWeight,
} from './styled';

export default function IdealWeightHeight(props) {
  const { growthData } = props;
  return (
    <IdealBabySection>
      <BabySection>
        <IdealMeasurmentHeight>
          <p className="whiteOpacity">IDEAL HEIGHT</p>
          <p className="normal">{growthData?.ideal_height}</p>
        </IdealMeasurmentHeight>
        <div className="babyImage">
          <img src={growthData?.image} alt="" />
        </div>
        <IdealMeasurmentWeight>
          <p className="whiteOpacity">IDEAL WEIGHT</p>
          <p>{growthData?.ideal_weight}</p>
        </IdealMeasurmentWeight>
      </BabySection>
      <div className="babyImageSection">
        <img src={growthData?.image} alt="" />
      </div>
    </IdealBabySection>
  );
}
